import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http';

var getEndpointPrefix = function getEndpointPrefix() {
  return "".concat(bundle.apiLocation(), "/translations");
};

var validateOptions = function validateOptions(functionName, requiredOptions, options) {
  var missing = requiredOptions.filter(function (requiredOption) {
    return !options[requiredOption];
  });

  if (missing.length > 0) {
    throw new Error("".concat(functionName, " failed! The following required options are missing: ").concat(missing));
  }
};

export var fetchAvailableLocales = function fetchAvailableLocales() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var paramModifier = function paramModifier(params) {
    return options.localeCode ? _objectSpread(_objectSpread({}, params), {}, {
      localized: options.localeCode
    }) : params;
  };

  return axios.get("".concat(bundle.apiLocation(), "/meta/locales"), {
    params: paramModifier(paramBuilder(options)),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      locales: response.data.locales
    };
  })["catch"](handleErrors);
};
export var clearTranslationsCache = function clearTranslationsCache() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios["delete"]("".concat(getEndpointPrefix(), "/cache"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      message: response.data.message
    };
  })["catch"](handleErrors);
};
export var fetchStagedTranslations = function fetchStagedTranslations() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var paramModifier = function paramModifier(params) {
    return options.contextName ? _objectSpread(_objectSpread({}, params), {}, {
      context: options.contextName
    }) : params;
  };

  return axios.get("".concat(getEndpointPrefix(), "/staged"), {
    params: paramModifier(paramBuilder(options)),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      changes: response.data.changes
    };
  })["catch"](handleErrors);
};
export var fetchDefaultLocale = function fetchDefaultLocale() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(getEndpointPrefix(), "/settings/defaultLocale"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      defaultLocale: response.data.defaultLocale
    };
  })["catch"](handleErrors);
};
export var setDefaultLocale = function setDefaultLocale() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('setDefaultLocale', ['localeCode'], options);
  return axios.put("".concat(getEndpointPrefix(), "/settings/defaultLocale"), {
    code: options.localeCode
  }, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      defaultLocale: response.data.defaultLocale
    };
  })["catch"](handleErrors);
};
export var fetchEnabledLocales = function fetchEnabledLocales() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(getEndpointPrefix(), "/settings/locales"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      locales: response.data.locales
    };
  })["catch"](handleErrors);
};
export var enableLocale = function enableLocale() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('enableLocale', ['localeCode'], options);
  return axios.post("".concat(getEndpointPrefix(), "/settings/locales"), {
    code: options.localeCode
  }, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      locale: response.data.locale
    };
  })["catch"](handleErrors);
};
export var disableLocale = function disableLocale() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('disableLocale', ['localeCode'], options);
  return axios["delete"]("".concat(getEndpointPrefix(), "/settings/locales/").concat(options.localeCode), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      locale: response.data.locale
    };
  })["catch"](handleErrors);
};
export var fetchContexts = function fetchContexts() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var paramModifier = function paramModifier(params) {
    if (options.custom) {
      return _objectSpread(_objectSpread({}, params), {}, {
        custom: true
      });
    } else if (options.expected) {
      return _objectSpread(_objectSpread({}, params), {}, {
        expected: true
      });
    } else if (options.unexpected) {
      return _objectSpread(_objectSpread({}, params), {}, {
        unexpected: true
      });
    } else {
      return params;
    }
  };

  return axios.get("".concat(getEndpointPrefix(), "/contexts"), {
    params: paramModifier(paramBuilder(options)),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      contexts: response.data.contexts.map(function (c) {
        return {
          name: c.name,
          kapp: c.name.startsWith('kapps') ? c.name.split('.')[1] : null,
          form: c.name.startsWith('kapps') ? c.name.split('.')[3] : c.name.startsWith('datastore') ? c.name.split('.')[2] : null
        };
      })
    };
  })["catch"](handleErrors);
};
export var createContext = function createContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createContext', ['context'], options);
  return axios.post("".concat(getEndpointPrefix(), "/contexts"), options.context, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      context: response.data.context
    };
  })["catch"](handleErrors);
};
export var updateContext = function updateContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateContext', ['contextName', 'context'], options);
  return axios.put("".concat(getEndpointPrefix(), "/contexts/").concat(options.contextName), options.context, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      context: response.data.context
    };
  })["catch"](handleErrors);
};
export var deleteContext = function deleteContext() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteContext', ['contextName'], options);
  return axios["delete"]("".concat(getEndpointPrefix(), "/contexts/").concat(options.contextName), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      context: response.data.context
    };
  })["catch"](handleErrors);
};
export var fetchContextKeys = function fetchContextKeys() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchContextKeys', ['contextName'], options);
  return axios.get("".concat(getEndpointPrefix(), "/contexts/").concat(options.contextName, "/keys"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      keys: response.data.keys
    };
  })["catch"](handleErrors);
};
export var updateContextKey = function updateContextKey() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateContextKey', ['contextName', 'keyHash', 'key'], options);
  return axios.put("".concat(getEndpointPrefix(), "/contexts/").concat(options.contextName, "/keys/").concat(options.keyHash), options.key, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      message: response.data.message
    };
  })["catch"](handleErrors);
};
export var fetchTranslations = function fetchTranslations() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.cache) {
    validateOptions('fetchTranslations', ['contextName', 'localeCode'], options);
  }

  var paramModifier = function paramModifier(params) {
    var result = _objectSpread({}, params);

    if (options.cache) {
      result.cache = true;
    }

    if (options.contextName) {
      result.context = options.contextName;
    }

    if (options.localeCode) {
      result.locale = options.localeCode;
    }

    if (options.keyHash) {
      result.keyHash = options.keyHash;
    }

    if (options.missing) {
      result.missing = options.missing;
    }

    if (options["export"] && !options.cache) {
      result.download = true;
    }

    return result;
  };

  return axios.get("".concat(getEndpointPrefix(), "/entries"), {
    params: paramModifier(paramBuilder(options)),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      entries: response.data.hasOwnProperty('entries') ? response.data.entries : response.data
    };
  })["catch"](handleErrors);
};
export var upsertTranslations = function upsertTranslations() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = null;

  if (options["import"]) {
    validateOptions('upsertTranslations', ['file'], options);
    data = new FormData();
    data.append('file', options.file);
  } else if (options.translations) {
    validateOptions('upsertTranslations', ['translations'], options);
    data = options.translations;
  } else {
    validateOptions('upsertTranslations', ['translation'], options);
    data = options.translation;
  }

  var paramModifier = function paramModifier(params) {
    return options["import"] ? _objectSpread(_objectSpread({}, params), {}, {
      "import": options["import"]
    }) : params;
  };

  var headerModifier = function headerModifier(headers) {
    return options["import"] ? _objectSpread(_objectSpread({}, headers), {}, {
      'Content-Type': 'multipart/form-data'
    }) : headers;
  };

  return axios.post("".concat(getEndpointPrefix(), "/entries"), data, {
    params: paramModifier(paramBuilder(options)),
    headers: headerModifier(headerBuilder(options))
  }).then(function (response) {
    return {
      message: response.data.message
    };
  })["catch"](handleErrors);
};
export var deleteTranslations = function deleteTranslations() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.keyHash) {
    validateOptions('deleteTranslations', ['contextName'], options);
  }

  var paramModifier = function paramModifier(params) {
    var result = _objectSpread({}, params);

    if (options.contextName) {
      result.context = options.contextName;
    }

    if (options.localeCode) {
      result.locale = options.localeCode;
    }

    if (options.keyHash) {
      result.keyHash = options.keyHash;
    }

    return result;
  };

  return axios["delete"]("".concat(getEndpointPrefix(), "/entries"), {
    params: paramModifier(paramBuilder(options)),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      message: response.data.message
    };
  })["catch"](handleErrors);
};